// extracted by mini-css-extract-plugin
module.exports = {"root":"AddClientsModal_root__1e53B","buttonGroup":"AddClientsModal_buttonGroup__2SXPW","modalHeader":"AddClientsModal_modalHeader__1Vsqo"};